import React, { createContext, useContext, useState } from "react";
import AccountDataService from "../Services/accountDataService";

const ParameterContext = createContext();

const STORAGE_KEY = "equestrolog_account_parameters";

export const ParameterProvider = ({ children }) => {
  const [parameterState, setParameterStateInternal] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);

      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const setParameterState = (parameters) => {
    setParameterStateInternal(parameters);

    if (parameters == null) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(parameters));
    }
  };

  const clearParameters = () => {
    setParameterStateInternal(null);
    localStorage.removeItem(STORAGE_KEY);
  };

  return (
    <ParameterContext.Provider
      value={{
        parameterState,
        setParameterState,
        clearParameters,
      }}>
      {children}
    </ParameterContext.Provider>
  );
};

export const useParameters = () => {
  const context = useContext(ParameterContext);

  if (!context) {
    throw new Error("useParameters must be used within a ParameterProvider");
  }

  return context;
};
